namespace RedBullMOBILE360.CustomerCare {

    @Serenity.Decorators.registerClass('RedBullMOBILE360.CustomerCare.UnBlockedSMSCustomersDialog')
    export class UnBlockedSMSCustomersDialog extends Serenity.EntityDialog<UnBlockedSMSCustomersRow, any> {
        protected getFormKey() { return UnBlockedSMSCustomersForm.formKey; }
        protected getIdProperty() { return UnBlockedSMSCustomersRow.idProperty; }
        protected getLocalTextPrefix() { return UnBlockedSMSCustomersRow.localTextPrefix; }
        protected getNameProperty() { return UnBlockedSMSCustomersRow.nameProperty; }
        protected getService() { return UnBlockedSMSCustomersService.baseUrl; }
        protected getDeletePermission() { return UnBlockedSMSCustomersRow.deletePermission; }
        protected getInsertPermission() { return UnBlockedSMSCustomersRow.insertPermission; }
        protected getUpdatePermission() { return UnBlockedSMSCustomersRow.updatePermission; }

        protected form = new UnBlockedSMSCustomersForm(this.idPrefix);
    }
}